import { render, staticRenderFns } from "./AExt.vue?vue&type=template&id=35baa5b8&"
import script from "./AExt.vue?vue&type=script&lang=js&"
export * from "./AExt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports